import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { constants } from 'focus-lock';
import { inlineProp } from './util';

var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return React.createElement("div", _extends({}, inlineProp(constants.FOCUS_AUTO, !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
export default AutoFocusInside;


//////////////////
// WEBPACK FOOTER
// ./~/react-focus-lock/dist/es2015/AutoFocusInside.js
// module id = 1085
// module chunks = 0